import PageTitle from '../../utils/PageTitle';
import UserInfoEditableArea from './Components/UserInfoEditableArea';
import UserInfoRow from './Components/UserInfoRow';
import UserProfileProvider from './UserProfileProvider';

function UserProfilePage() {
    // set page title
    PageTitle(`Profile`);

    return (
        <UserProfileProvider>
            <div className="flex justify-center">
                <div className=" inner_page_cont w-full max-w-[900px] p-4 md:p-[50px]">
                    <UserInfoRow />
                    <UserInfoEditableArea />
                </div>
            </div>
        </UserProfileProvider>
    );
}

export default UserProfilePage;
